import { Elements } from '@stripe/react-stripe-js'
import { Stripe, StripeElementsOptionsMode } from '@stripe/stripe-js'

import { SetupForm } from '@/components/checkout/stripe-setup-form'

import { Props as SetupFormProps } from './stripe-setup-form'

type Props = {
  stripePromise: Stripe | PromiseLike<Stripe | null> | null
  options: StripeElementsOptionsMode
} & SetupFormProps

export const StripeSetupFormWrapper = ({
  siteSlug,
  stripePromise,
  options,
  ...props
}: Props) => {
  return (
    <Elements stripe={stripePromise} options={options}>
      <SetupForm siteSlug={siteSlug} {...props} />
    </Elements>
  )
}
